import { configureStore } from '@reduxjs/toolkit';
import registerReducer from './slices/register';
import adaptReducer from './slices/adapt';

export const store = configureStore({
  reducer: {
    register: registerReducer,
    adapt: adaptReducer,
  },
});
